import gql from 'graphql-tag';

import { getSingleProp } from 'src/lib/graphql';
import { executeGqlQuery } from 'src/graphql/client';
import { BRIEF_FRAGMENT } from 'src/graphql/brief/schema';

const QUERY = gql`
  query LastUsedProject($workspaceId: ID!, $projectTypes: [String!], $briefTypes: [String!]) {
    lastUsedProject(
      workspaceId: $workspaceId
      projectTypes: $projectTypes
      briefTypes: $briefTypes
    ) {
      id
      contentTaxonomy {
        id
      }
      brief {
        ...Brief
      }
      suggestionAnnotations {
        type
        content
      }
      customerPersonas {
        id
      }
    }
  }
  ${BRIEF_FRAGMENT}
`;

export const queryLastUsedProject = (workspaceId, projectTypes, briefTypes) =>
  executeGqlQuery({
    query: QUERY,
    variables: { workspaceId, projectTypes, briefTypes },
  }).then(({ data }) => getSingleProp(data));
